import apiRequest from './apiClient';

/**
 * Отправить обращение из формы обратной связи.
 *
 * @param {Object} payload
 * @param {'BUG'|'IDEA'|'QUESTION'} payload.type тип обращения
 * @param {string} payload.message текст
 * @param {string} payload.route маршрут (path + search), с которого отправлено
 * @param {Object} payload.context технический контекст (collectFeedbackContext)
 * @returns {Promise<{publicId: string, createdAt: string}>}
 */
export const sendFeedback = ({ type, message, route, context }) =>
  apiRequest('/api/feedback', {
    method: 'POST',
    body: JSON.stringify({ type, message, route, context }),
  });
